<template>
    <div v-if="isValidContract" class="hotline-contacts">
        <h5>Contacts</h5>

        <div v-if="hotlineContacts.length > 0">
            <div v-for="(hotlineContact, idx) in hotlineContacts" :key="'hotline-contact-' + idx" class="hotline-contact">
                <div>
                    <dt>Nom : </dt>
                    <dd>{{ hotlineContact.name }}</dd>
                </div>

                <div v-if="hotlineContact.phone">
                    <dt>Téléphone : </dt>
                    <dd>{{ hotlineContact.phone }}</dd>
                </div>

                <div v-if="hotlineContact.email">
                    <dt>E-mail : </dt>
                    <dd>{{ hotlineContact.email }}</dd>
                </div>
            </div>
        </div>
        <div v-else>Aucun contact n'a été renseigné pour ce contrat</div>
    </div>
    <div v-else>Aucune option de permanence téléphonique simple n'est associée à ce contrat</div>
</template>

<script>
export default {
    name:"HotlineContacts",
    props:["contract"],

    data () {
        return {}
    },

    computed: {
        simpleHotlineContractOption() {
            return _.filter(this.contract.contract_options, co => co.option.simple_hotline == true && _.includes(['active', 'pending-termination'], co.status))[0]
        },

        isValidContract() {
            return this.simpleHotlineContractOption != undefined
        },

        hotlineContacts() {
            return this.isValidContract ? this.simpleHotlineContractOption.hotline_contacts : []
        }
    }
}
</script>

<style lang="scss" scoped>
    .hotline-contacts dt, .hotline-contacts dd { 
        display: inline-block;
    }
    .hotline-contact { 
        margin-bottom: 10px; 
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/HotlineContent/HotlineContacts.vue